/**
 * 弹窗场景枚举
 */
export enum PopupIdEnum {
  /** 预申请选择-加载返回 */
  PRE_APPLY_CHOOSE_LOADING_BACK = 'preApplyChoose_loadingBack',
  /** 预申请选择-合同返回 */
  PRE_APPLY_CHOOSE_CONTRACT_BACK = 'preApplyChoose_contractBack',
  /** 预申请选择-贷超半流程返回 */
  PRE_APPLY_CHOOSE_LOAN_MARKET_HALF_BACK = 'preApplyChoose_loanMarketHalfBack',
  /** 授信验证-身份返回 */
  VERIFY_CREDIT_IDENTITY_BACK = 'verifyCredit_identityBack',
}

/** 弹窗有关状态：查询疲劳度、选择离开 */
export enum PopupRelatedStatusEnum {
  /** 初始状态 */
  INIT = 'init',
  /** 查询疲劳度中 */
  CHECKING_SHOW = 'checking_show',
  /** 已选择离开 */
  CHOSEN_LEAVE = 'chosen_leave',
  /** 一次访问内疲劳(1次最多1次) */
  ONCE_ENTER_TIRED = 'once_enter_tired',
}

/**
 * 弹窗展示疲劳度控制
 */
export interface PopupShowFatigueControl {
  /** 是否可以弹窗 */
  canShow: boolean;
  /** 当前已弹窗次数 */
  currentCount: number;
  /** 配置的最大弹窗次数 */
  maxCount: number;
  /** 配置的时间窗口（天数） */
  timeWindowDays: number;
}
